import { Select } from 'antd';
import { FC, useEffect } from 'react';
import useAxios from '../hooks/useAxios';
import { IGetSemesterCourseSubjects, ISubject } from '../models/subject.model';
import { getSemesterCourseSubjects } from '../api/subject.api';
import Loader from './Loader';
import ErrorResponse from './ErrorResponse';
import { useTranslation } from 'react-i18next';

interface IProps {
  semesterCourseCode?: number | undefined;
  subjectCode: number | undefined;
  setSubjectCode: (subjectCode: number) => void;
  subjects?: ISubject[];
  disabled?: boolean;
}

const SelectSemesterCourseSubject: FC<IProps> = ({
  semesterCourseCode,
  subjectCode,
  setSubjectCode,
  subjects,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetSemesterCourseSubjects>();

  useEffect(() => {
    if (semesterCourseCode) {
      execute(getSemesterCourseSubjects({ semesterCourseCode }));
    }
  }, [semesterCourseCode]);

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <Select
        className="w-100"
        placeholder={t('common.placeholder.2')}
        value={subjectCode}
        onChange={(value) => setSubjectCode(value)}
        disabled={disabled ? disabled : !subjects && !semesterCourseCode}
      >
        {(subjects || res?.data)?.map((item: ISubject) => (
          <Select.Option key={item.subjectCode} value={item.subjectCode}>
            {item.subjectName}
          </Select.Option>
        ))}
      </Select>
    </>
  );
};

export default SelectSemesterCourseSubject;
